import BaseAPI from './base'
/**
 * API quản lý bài tập học sinh
 */
class StudentExerciseAPI extends BaseAPI {}

export default new StudentExerciseAPI('v1/student-exercise', 'StudentExercise')
